import { render, staticRenderFns } from "./testproduct.vue?vue&type=template&id=fe643688&"
import script from "./testproduct.vue?vue&type=script&lang=js&"
export * from "./testproduct.vue?vue&type=script&lang=js&"
import style0 from "./testproduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports